import { useState } from 'react';
import { useAuthStore } from '../../store/authStore';

export default function Header({ toggleSidebar }) {
  const { user } = useAuthStore();
  const [showNotifications, setShowNotifications] = useState(false);

  const notifications = [
    { id: 1, message: '5 WECs expiring this month', type: 'warning', time: '2 hours ago' },
    { id: 2, message: 'New retailer registration pending', type: 'info', time: '4 hours ago' },
    { id: 3, message: 'Monthly report generated', type: 'success', time: '1 day ago' },
  ];

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-4 sm:px-6 py-3 sm:py-4 flex-shrink-0">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-0">

        {/* TOP ROW: Hamburger + Title */}
        <div className="flex items-center">
          {/* ⭐ Mobile Menu Button (Hamburger) - visible only on mobile */}
          <button
            className="md:hidden mr-3 text-gray-700 text-2xl"
            onClick={toggleSidebar}
          >
            <i className="ri-menu-line"></i>
          </button>

          {/* LEFT SECTION */}
          <div>
            <h2 className="text-base sm:text-xl font-semibold text-gray-900">
              Welcome back, {user?.name}
            </h2>
            <p className="text-sm sm:text-xs text-gray-600">
              {new Date().toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p>
          </div>
        </div>

        {/* RIGHT SECTION - stacks below on mobile */}
        <div className="flex items-center space-x-2 sm:space-x-4">

          <div className="relative">
            {/* (Your notification code kept as it is but commented) */}
          </div>

        </div>
      </div>
    </header>
  );
}
